import { PageHero } from "@/components/PageHero";
import { GalleryGrid } from "@/components/GalleryGrid";
import { QuoteCTA } from "@/components/QuoteCTA";

export default function Gallery() {
  return (
    <>
      <PageHero kicker="Gallery" title="Components. Details. Precision."
        text="Browse our tractor, implement, backhoe loader and 3-point linkage parts by category."
        image="https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600" />
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <GalleryGrid filterable />
        </div>
      </section>
      <QuoteCTA />
    </>
  );
}
